module.exports = __webpack_public_path__ + "img/04-1.70990ec5.png";